import {Checkbox} from '@mui/material';
import {selectPreference, updatePreference} from '@qep/shared/src';
import {LoadingIndicator} from '../loading-indicator/loading-indicator';
import './preferences.scss';

export function OrderBookPreferences() {
  const {preference, isLoading} = selectPreference<boolean>('orderBook.keepArmed');
  const mutation = updatePreference<boolean>('orderBook.keepArmed');
  if (isLoading) {
    return (
      <LoadingIndicator />
    );
  }

  const keepArmed = mutation.variables ?? Boolean(preference);

  return (
    <div className='orderBookPreferences'>
      <div className='orderBookPreferences__input'>
        <Checkbox
          id='order-book-keep-armed'
          disabled={mutation.isPending}
          checked={keepArmed}
          onChange={event => {
            mutation.mutate(event.target.checked);
          }}
        />
        <label htmlFor='order-book-keep-armed'>Default Armed</label>
      </div>
    </div>
  );
}
